// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603021251/js/" + chunkId + "." + {"44":"cb0e08ae","225":"84a6b901","481":"b6887054","486":"ac59ef27","770":"c2077df3"}[chunkId] + ".0.015376967322543678.chunk.js";
};